import React, { useState, useEffect, useRef } from 'react';

const ALL_LANGUAGES = [
  { code: 'ru', label: 'RU', name: 'Русский', flag: '🇷🇺' },
  { code: 'uz', label: 'UZ', name: "O'zbek", flag: '🇺🇿' },
  { code: 'en', label: 'EN', name: 'English', flag: '🇬🇧' },
];

const ALL_PROVIDERS = [
  { code: 'payme', label: 'Payme', color: '#00AAFF' },
  { code: 'click', label: 'Click', color: '#FF6B35' },
  { code: 'uzum', label: 'Uzum', color: '#7B2FBE' },
];

function Toggle({ value, onChange, disabled }) {
  return (
    <div
      onClick={() => !disabled && onChange(!value)}
      style={{
        width: '48px', height: '28px',
        borderRadius: '14px',
        backgroundColor: value ? '#34C759' : '#E0E0E0',
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'background 0.2s',
        flexShrink: 0,
      }}
    >
      <div style={{
        position: 'absolute',
        top: '3px',
        left: value ? '23px' : '3px',
        width: '22px', height: '22px',
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
        transition: 'left 0.2s',
      }} />
    </div>
  );
}

function Chip({ active, onClick, children, color, disabled }) {
  return (
    <button
      type="button"
      onClick={() => !disabled && onClick()}
      style={{
        padding: '8px 14px',
        borderRadius: '20px',
        border: active ? `2px solid ${color || '#111'}` : '2px solid #E0E0E0',
        backgroundColor: active ? (color ? `${color}22` : '#F0F0F0') : '#fff',
        color: active ? (color || '#111') : '#999',
        fontSize: '14px', fontWeight: active ? '700' : '400',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.15s',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {children}
    </button>
  );
}

function CsvImport({ api, slug, onSuccess }) {
  const [csv, setCsv] = useState('');
  const [fileName, setFileName] = useState('');
  const [mode, setMode] = useState('skip');
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [err, setErr] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const readFile = (file) => {
    if (!file || !file.name.toLowerCase().endsWith('.csv')) {
      setErr('Выберите файл .csv');
      return;
    }
    setErr('');
    const reader = new FileReader();
    reader.onload = (e) => {
      setCsv(e.target.result || '');
      setFileName(file.name);
    };
    reader.readAsText(file, 'UTF-8');
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer?.files?.[0];
    if (file) readFile(file);
  };

  const handleImport = async () => {
    if (!csv.trim() || !api || !slug) return;
    setLoading(true); setReport(null); setErr('');
    try {
      const { data } = await api.post(`/api/admin/restaurant/${slug}/import-csv`, {
        csv: csv.trim(),
        mode: mode === 'upsert' ? 'upsert' : 'skip',
      });
      setReport(data.report);
      if ((data.report?.created > 0 || data.report?.updated > 0)) onSuccess?.();
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: '12px', marginBottom: '10px', alignItems: 'center' }}>
        <label style={{ fontSize: '13px', fontWeight: '600' }}>
          <input
            type="radio"
            name="csvMode"
            checked={mode === 'skip'}
            onChange={() => setMode('skip')}
            style={{ marginRight: '6px' }}
          />
          Пропускать дубли
        </label>
        <label style={{ fontSize: '13px', fontWeight: '600' }}>
          <input
            type="radio"
            name="csvMode"
            checked={mode === 'upsert'}
            onChange={() => setMode('upsert')}
            style={{ marginRight: '6px' }}
          />
          Обновлять дубли (цена, описание)
        </label>
      </div>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
        style={{
          width: '100%', minHeight: '120px', padding: '24px',
          borderRadius: '12px', border: `2px dashed ${isDragging ? '#111' : '#ccc'}`,
          backgroundColor: isDragging ? '#f5f5f5' : '#fafafa',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', transition: 'all 0.2s', boxSizing: 'border-box',
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          style={{ display: 'none' }}
          onChange={(e) => { const f = e.target.files?.[0]; if (f) readFile(f); e.target.value = ''; }}
        />
        {fileName ? (
          <>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#111', marginBottom: '4px' }}>📄 {fileName}</span>
            <span style={{ fontSize: '12px', color: '#666' }}>Нажмите для выбора другого файла</span>
          </>
        ) : (
          <>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#666', marginBottom: '4px' }}>📥 Перетащите CSV или нажмите для выбора</span>
            <span style={{ fontSize: '12px', color: '#999' }}>category_ru, name_ru, price...</span>
          </>
        )}
      </div>
      <button
        type="button"
        onClick={handleImport}
        disabled={loading || !csv.trim()}
        style={{
          marginTop: '8px', padding: '10px 20px', borderRadius: '10px',
          border: 'none', backgroundColor: '#111', color: '#fff',
          fontSize: '14px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? '⏳ Импорт...' : '📥 Импортировать'}
      </button>
      {report && (
        <div style={{ marginTop: '14px', fontSize: '13px', color: '#333' }}>
          ✅ Создано: {report.created}
          {(report.updated ?? 0) > 0 && ` | Обновлено: ${report.updated}`}
          {` | Пропущено: ${report.skipped}`}
          {report.errors?.length > 0 && (
            <div style={{ marginTop: '8px', color: '#CC0000', fontSize: '12px' }}>
              Ошибки: {report.errors.map((e) => `${e.row}: ${e.error}`).join('; ')}
            </div>
          )}
        </div>
      )}
      {err && <div style={{ marginTop: '8px', color: '#CC0000', fontSize: '12px' }}>⚠️ {err}</div>}
    </div>
  );
}

export default function FeatureSettings({ restaurant, api, onImportSuccess }) {
  const slug = restaurant?.slug;

  const [langs, setLangs] = useState(['ru', 'uz', 'en']);
  const [payEnabled, setPayEnabled] = useState(true);
  const [providers, setProviders] = useState(['payme']);
  const [tgToken, setTgToken]     = useState('');
  const [tgChatId, setTgChatId]   = useState('');
  const [tgTesting, setTgTesting] = useState(false);
  const [tgTestMsg, setTgTestMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!slug || !api) return;
    api.get(`/api/admin/restaurant/${slug}/feature-settings`)
      .then((r) => {
        setLangs(r.data.enabled_languages || ['ru', 'uz', 'en']);
        setPayEnabled(r.data.payment_enabled !== false);
        setProviders(r.data.payment_providers || ['payme']);
        setTgToken(r.data.telegram_bot_token || '');
        setTgChatId(r.data.telegram_chat_id  || '');
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [slug, api]);

  const handleSave = async () => {
    if (langs.length === 0) { setError('Нужен хотя бы один язык'); return; }
    setSaving(true); setError('');
    try {
      await api.patch(`/api/admin/restaurant/${slug}/feature-settings`, {
        enabled_languages:  langs,
        payment_enabled:    payEnabled,
        payment_providers:  providers,
        telegram_bot_token: tgToken  || '',
        telegram_chat_id:   tgChatId || '',
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleTgTest = async () => {
    if (!tgToken || !tgChatId) {
      setTgTestMsg('⚠️ Заполните токен и Chat ID');
      return;
    }
    setTgTesting(true); setTgTestMsg('');
    try {
      await api.post(`/api/admin/restaurant/${slug}/test-telegram`);
      setTgTestMsg('✅ Сообщение отправлено!');
    } catch (e) {
      setTgTestMsg('❌ ' + (e.response?.data?.error || e.message));
    } finally {
      setTgTesting(false);
      setTimeout(() => setTgTestMsg(''), 4000);
    }
  };

  const toggleLang = (code) => {
    if (langs.includes(code)) {
      if (langs.length === 1) return;
      setLangs(langs.filter((l) => l !== code));
    } else {
      setLangs([...langs, code]);
    }
  };

  const toggleProvider = (code) => {
    if (providers.includes(code)) {
      setProviders(providers.filter((p) => p !== code));
    } else {
      setProviders([...providers, code]);
    }
  };

  if (loading) return (
    <div style={{ padding: '32px', textAlign: 'center', color: '#999' }}>
      Загрузка...
    </div>
  );

  return (
    <div style={{ fontFamily: '-apple-system, sans-serif' }}>

      <div style={{
        backgroundColor: '#fff', borderRadius: '16px',
        padding: '16px', marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      }}>
        <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '4px' }}>
          🌐 Языки меню
        </div>
        <div style={{ fontSize: '13px', color: '#999', marginBottom: '14px' }}>
          Гость увидит только включённые языки
        </div>

        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {ALL_LANGUAGES.map((l) => (
            <Chip
              key={l.code}
              active={langs.includes(l.code)}
              onClick={() => toggleLang(l.code)}
              disabled={langs.includes(l.code) && langs.length === 1}
            >
              {l.flag} {l.label} — {l.name}
            </Chip>
          ))}
        </div>

        {langs.length === 1 && (
          <div style={{
            marginTop: '10px', fontSize: '12px', color: '#FF9500',
            backgroundColor: '#FFF8EC', padding: '8px 12px',
            borderRadius: '8px',
          }}>
            ⚠️ Переключатель языков будет скрыт (только 1 язык)
          </div>
        )}
      </div>

      <div style={{
        backgroundColor: '#fff', borderRadius: '16px',
        padding: '16px', marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', marginBottom: '14px',
        }}>
          <div>
            <div style={{ fontWeight: '700', fontSize: '15px' }}>
              💳 Онлайн-оплата
            </div>
            <div style={{ fontSize: '13px', color: '#999', marginTop: '2px' }}>
              {payEnabled
                ? 'Кнопка оплаты показывается гостю'
                : 'Кнопка оплаты скрыта — только счёт'}
            </div>
          </div>
          <Toggle value={payEnabled} onChange={setPayEnabled} />
        </div>

        <div style={{ opacity: payEnabled ? 1 : 0.4, transition: 'opacity 0.2s' }}>
          <div style={{ fontSize: '12px', color: '#999', marginBottom: '8px', fontWeight: '600' }}>
            ПРОВАЙДЕРЫ
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {ALL_PROVIDERS.map((p) => (
              <Chip
                key={p.code}
                active={providers.includes(p.code)}
                onClick={() => toggleProvider(p.code)}
                color={p.color}
                disabled={!payEnabled}
              >
                {p.label}
              </Chip>
            ))}
          </div>
        </div>

        <div style={{
          marginTop: '16px',
          backgroundColor: '#1A1A1A',
          borderRadius: '12px',
          padding: '14px',
        }}>
          <div style={{ fontSize: '11px', color: '#666', marginBottom: '10px', fontWeight: '600' }}>
            ПРЕВЬЮ ЭКРАНА ЗАКАЗА
          </div>
          <div style={{
            fontSize: '13px', color: '#fff', fontWeight: '700',
            textAlign: 'center', marginBottom: '8px',
          }}>
            ✅ Заказ №42 принят!
          </div>
          <div style={{
            backgroundColor: '#2A2A2A', borderRadius: '8px',
            padding: '10px', textAlign: 'center',
            marginBottom: '10px',
          }}>
            <div style={{ fontSize: '11px', color: '#666' }}>К оплате</div>
            <div style={{ fontSize: '18px', color: '#fff', fontWeight: '700' }}>
              45 000 сум
            </div>
          </div>

          {payEnabled && providers.includes('payme') && (
            <div style={{
              backgroundColor: '#00AAFF', borderRadius: '8px',
              padding: '10px', textAlign: 'center',
              color: '#fff', fontSize: '13px', fontWeight: '600',
              marginBottom: '8px',
            }}>
              💳 Оплатить через Payme
            </div>
          )}
          {payEnabled && providers.includes('click') && (
            <div style={{
              backgroundColor: '#FF6B35', borderRadius: '8px',
              padding: '10px', textAlign: 'center',
              color: '#fff', fontSize: '13px', fontWeight: '600',
              marginBottom: '8px',
            }}>
              ⚡ Оплатить через Click
            </div>
          )}
          {payEnabled && providers.includes('uzum') && (
            <div style={{
              backgroundColor: '#7B2FBE', borderRadius: '8px',
              padding: '10px', textAlign: 'center',
              color: '#fff', fontSize: '13px', fontWeight: '600',
              marginBottom: '8px',
            }}>
              💜 Оплатить через Uzum
            </div>
          )}

          <div style={{
            backgroundColor: '#2A2A2A', borderRadius: '8px',
            padding: '10px', textAlign: 'center',
            color: '#fff', fontSize: '13px',
          }}>
            Закрыть
          </div>
        </div>
      </div>

      {/* Telegram */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px',
        padding: '16px', marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      }}>
        <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '4px' }}>
          ✈️ Telegram-бот
        </div>
        <div style={{ fontSize: '13px', color: '#999', marginBottom: '14px' }}>
          Для отправки банкетов и уведомлений. Создайте бота через{' '}
          <a href="https://t.me/BotFather" target="_blank" rel="noreferrer"
            style={{ color: '#007AFF' }}>@BotFather</a>,
          {' '}получите токен и добавьте бота в чат/группу.
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div>
            <div style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>
              Bot Token
            </div>
            <input
              value={tgToken}
              onChange={(e) => setTgToken(e.target.value)}
              placeholder="123456789:AAF..."
              style={tgInputStyle}
              autoComplete="off"
              spellCheck={false}
            />
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>
              Chat ID
              <span style={{ fontSize: '11px', color: '#999', fontWeight: '400', marginLeft: '6px' }}>
                (личный: @username или числовой ID; группа: -100xxx)
              </span>
            </div>
            <input
              value={tgChatId}
              onChange={(e) => setTgChatId(e.target.value)}
              placeholder="-1001234567890"
              style={tgInputStyle}
              autoComplete="off"
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={handleTgTest}
              disabled={tgTesting || !tgToken || !tgChatId}
              style={{
                padding: '9px 16px', borderRadius: '10px', border: 'none',
                backgroundColor: (!tgToken || !tgChatId) ? '#F0F0F0' : '#229ED9',
                color: (!tgToken || !tgChatId) ? '#999' : '#fff',
                fontSize: '13px', fontWeight: '600',
                cursor: (!tgToken || !tgChatId) ? 'not-allowed' : 'pointer',
              }}
            >
              {tgTesting ? '⏳ Отправка...' : '📨 Тест соединения'}
            </button>
            {tgTestMsg && (
              <span style={{
                fontSize: '13px', fontWeight: '500',
                color: tgTestMsg.startsWith('✅') ? '#34C759' : '#E85D4A',
              }}>
                {tgTestMsg}
              </span>
            )}
          </div>

          <div style={{
            backgroundColor: '#F8F8F8', borderRadius: '10px',
            padding: '10px 12px', fontSize: '12px', color: '#666',
            lineHeight: '1.6',
          }}>
            💡 <b>Как получить Chat ID:</b><br />
            1. Добавьте бота в нужный чат/группу<br />
            2. Отправьте любое сообщение<br />
            3. Откройте{' '}
            <code style={{ backgroundColor: '#E8E8E8', padding: '1px 4px', borderRadius: '4px' }}>
              https://api.telegram.org/bot{'<TOKEN>'}/getUpdates
            </code>{' '}
            — найдите <code style={{ backgroundColor: '#E8E8E8', padding: '1px 4px', borderRadius: '4px' }}>chat.id</code>
          </div>
        </div>
      </div>

      {/* CSV импорт */}
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px',
        padding: '16px', marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      }}>
        <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '8px' }}>
          📥 Импорт из CSV
        </div>
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '12px' }}>
          Колонки: category_ru, category_uz, category_en, name_ru, name_uz, name_en, description_ru, description_uz, description_en, price, is_available
        </div>
        <CsvImport api={api} slug={slug} onSuccess={onImportSuccess} />
      </div>

      {error && !saving && (
        <div style={{
          backgroundColor: '#FFF0F0', color: '#CC0000',
          padding: '12px', borderRadius: '10px',
          fontSize: '13px', marginBottom: '12px',
        }}>
          ⚠️ {error}
        </div>
      )}

      <button
        type="button"
        onClick={handleSave}
        disabled={saving}
        style={{
          width: '100%', padding: '16px',
          borderRadius: '14px', border: 'none',
          backgroundColor: saving
            ? '#666'
            : saved
              ? '#34C759'
              : (error && !saving)
                ? '#C62828'
                : '#111',
          color: '#fff',
          fontSize: '15px', fontWeight: '700',
          cursor: saving ? 'not-allowed' : 'pointer',
          transition: 'background 0.3s',
        }}
      >
        {saving ? '⏳ Сохраняем...' : saved ? '✅ Сохранено!' : (error && !saving) ? '💾 Повторить сохранение' : '💾 Сохранить настройки'}
      </button>
    </div>
  );
}

const tgInputStyle = {
  width: '100%', padding: '11px 12px', borderRadius: '10px',
  border: '1px solid #E0E0E0', fontSize: '14px',
  outline: 'none', boxSizing: 'border-box',
  fontFamily: 'monospace',
};
